import React, { useEffect, useState } from "react";
import { Col, Input, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updatePortalPasswordThunk } from "../../../store/thunks/myProfileThunk";
import BottomRightButton from "../../../components/atoms/formFields/buttons/bottomRightButton";
import ModalWrapper from "../../../components/atoms/formFields/wrapperModal/modalWrapper";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import { resetUpdatePortalPassword } from "../../../store/slices/myProfileSlice";

const PasswordModal = ({ id }) => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.updatePortalPassword);

  console.log("data", useSelector((state) => state));
  console.log("data", data);

  const [passErrors, setPassErrors] = useState();
  const [formState, setFormState] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  //Toggle Password
  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  //Confirm Password
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const confirmPassword = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text");
      return;
    }
    setConfirmPasswordType("password");
  };

  const passwordUpdateHandel = (e) => {
    e.preventDefault();
    if (
      formState?.oldPassword &&
      formState?.password &&
      formState?.confirmPassword
    ) {
      dispatch(
        updatePortalPasswordThunk({
          myPasswordInput: {
            oldPassword: formState?.oldPassword,
            password: formState?.password,
            confirmPassword: formState?.confirmPassword,
          },
        })
      );
      setPassErrors();
    } else {
      setPassErrors({
        oldPassword: formState?.oldPassword
          ? ""
          : "Current Password is Mandatory",
        password: formState?.password ? "" : "New Password is Mandatory",
        confirmPassword: formState?.confirmPassword
          ? ""
          : "Confirm Password is Mandatory",
      });
    }
  };

  useEffect(() => {
    if (data) {
      setFormState({
        oldPassword: "",
        password: "",
        confirmPassword: "",
      });
      window.$(`#updatePasswordModal_${id}`).modal("hide");
      dispatch(resetUpdatePortalPassword());
    }
  }, [data, dispatch]);

  return (
    <>
      <ModalWrapper name="Change Password" id={`updatePasswordModal_${id}`}>
        <Row gutter={[12, 12]}>
          <Col className="gutter-row" xs={24}>
            <ContentInputField
              required={true}
              name={"Current Password"}
              type={"password"}
              autoComplete="off"
              className="rounded-0"
              value={formState?.oldPassword}
              errors={passErrors?.oldPassword}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  oldPassword: e.target.value,
                });
                setPassErrors({
                  ...passErrors,
                  oldPassword: e.target.value
                    ? ""
                    : "Current Password is Mandatory",
                });
              }}
            />
          </Col>
          <Col className="gutter-row" xs={24}>
            <ContentInputField
              required={true}
              name="New Password"
              type={passwordType}
              autoComplete="off"
              className="rounded-0"
              errors={passErrors?.password}
              value={formState?.password}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  password: e.target.value,
                });
                setPassErrors({
                  ...passErrors,
                  password: e.target.value ? "" : "New Password is Mandatory",
                });
              }}
            />

            <span
              className="input-group-text bg-transparent border-0 cursor-pointer"
              id="eyeToggle"
              onClick={togglePassword}
            >
              {passwordType === "password" ? (
                <i className="far fa-eye-slash w-15px"></i>
              ) : (
                <i className="far fa-eye w-15px"></i>
              )}
            </span>
          </Col>
          <Col className="gutter-row" xs={24}>
            <ContentInputField
              name="Confirm New Password"
              required={true}
              className="rounded-0"
              type={confirmPasswordType}
              errors={passErrors?.confirmPassword}
              value={formState?.confirmPassword}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  confirmPassword: e.target.value,
                });
                setPassErrors({
                  ...passErrors,
                  confirmPassword: e.target.value
                    ? ""
                    : "Confirm Password is Mandatory",
                });
              }}
            />

            <span
              className="input-group-text bg-transparent border-0 cursor-pointer"
              id="eyeToggle"
              onClick={confirmPassword}
            >
              {confirmPasswordType === "password" ? (
                <i className="far fa-eye-slash w-15px"></i>
              ) : (
                <i className="far fa-eye w-15px"></i>
              )}
            </span>
          </Col>
        </Row>
        <div className="modal-footer p-3 border-0">
          <BottomRightButton
            name="Change Password"
            className="all_bottom_buttons mr-auto mt-5"
            onClick={(e) => {
              passwordUpdateHandel(e);
            }}
          />
        </div>
      </ModalWrapper>
    </>
  );
};

export default PasswordModal;
